import { AxiosError } from 'axios';
import { appToast } from 'components/Basic/CustomToast';
import { patchObstructions } from 'components/tool/Editor/ButtonDiv/Facet/EditObstructionBtn/api';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { errorResponseHandler } from 'store/api/AxiosError';

export default function usePatchObstructionQuery() {
	const manualObs = useSelector((state: RootState) => state.toolNewPostions.data.manualObs);
	const deletedObstructionIDs = useSelector((state: RootState) => state.toolNewPostions.data.deletedObstructionIDs);
	const manualObsArray = Object.values(manualObs);
	const { uuid } = useSelector((state: RootState) => state.roofData.data);
	const editedObstructions = useSelector((state: RootState) => state.toolNewPostions.data.editedObstructions);
	const editedObsArray = Object.values(editedObstructions).filter((obs) => deletedObstructionIDs.includes(obs.id) === false);

	return useMutation(
		'patch-obstructions',
		async () => {
			await patchObstructions(uuid, manualObsArray, deletedObstructionIDs, editedObsArray);
		},
		{
			onError(error: AxiosError) {
				const message = errorResponseHandler(error).message;
				appToast.error(message);
			},
		}
	);
}